import Scene from '../../scene';
import { MpSdk } from 'src/types';
import { makePatchComponent, patchComponentType } from 'src/sdk-components/PatchComponent';
import { Tween, update as updateTween } from 'three/examples/jsm/libs/tween.module';
import { degToRad } from 'three/src/math/MathUtils';
class ScenePatch extends Scene {
  readonly mpSDK: any;

  public component: any;

  public fadeIn: any;

  public fadeOut: any;

  private hasSetInitialRotation = false;

  constructor(mpSDK: MpSdk) {
    super(mpSDK);
    this.mpSDK = mpSDK;
  }

  async init() {
    await this.mpSDK.Scene.register(patchComponentType, makePatchComponent);
  }

  async create(data: any) {
    const modelNode = await this.scene.createNode();
    this.component = await modelNode.addComponent(patchComponentType, {
      url: data.url,
      opacity: data.opacity,
    });
    modelNode.start();
    await this.initEvents();
    this.animate();
    return [modelNode, this.component];
  }

  async initEvents() {
    this.mpSDK.Sweep.current.subscribe((sweep) => {
      if (!sweep) return;
      const { x, y, z } = sweep.position;

      if (sweep.id !== '') {
        this.component.root.position.set(x, y - 1.2, z);

        // Set initial rotation once after tour is loaded and first valid sweep appears
        if (!this.hasSetInitialRotation) {
          this.setInitialRotation();
        }
      }
      if (!this.component.plane?.material) return;
      if (sweep.id === '') {
        if (!this.fadeOut) {
          this.fadeOut = new Tween(this.component.plane.material).to({ opacity: 0 }, 50);
        }
        this.fadeOut.start();
      }
      if (sweep.id !== '') {
        if (!this.fadeIn) {
          this.fadeIn = new Tween(this.component.plane.material).to(
            { opacity: this.component.inputs.opacity },
            50,
          );
        }
        this.fadeIn.start();
      }
    });
  }

  private async setInitialRotation() {
    try {
      const pose = await this.mpSDK.Camera.getPose();
      if (!pose || !this.component?.root) return;
      this.component.root.rotation.set(0, degToRad(pose.rotation.y) + Math.PI * 2, 0);
      this.hasSetInitialRotation = true;
    } catch (e) {
      console.log(e);
    }
  }

  animate = () => {
    requestAnimationFrame(this.animate);
    updateTween();
  };
}

export default ScenePatch;
